import {
  IExplodingFeeScheduleRuleset,
  IExplodingFeeScheduleCreateRequest,
  IExplodingFeeScheduleUpdateRequest,
} from "types/ExplodingFeeSchedule/ExplodingFeeSchedule";
import {
  IAllExplodingFeeScheduleResponse,
  IExplodingFeeScheduleResponse,
} from "types/ExplodingFeeSchedule/ExplodingFeeScheduleResponse";

import { api } from ".";

const explodingFeeScheduleQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllExplodingFeeSchedules: builder.query<
      IAllExplodingFeeScheduleResponse,
      null | void
    >({
      query: () => "exploding-fee-schedules/all",
    }),
    getExplodingFeeScheduleById: builder.query<
      IExplodingFeeScheduleResponse,
      string | undefined
    >({
      query: (id: string) => `exploding-fee-schedules/${id}`,
    }),
    createExplodingFeeSchedule: builder.mutation<
      IExplodingFeeScheduleRuleset,
      IExplodingFeeScheduleCreateRequest
    >({
      query: (newRuleset) => ({
        url: "exploding-fee-schedules",
        method: "POST",
        body: newRuleset,
      }),
    }),
    updateExplodingFeeSchedule: builder.mutation<
      IExplodingFeeScheduleRuleset,
      IExplodingFeeScheduleUpdateRequest
    >({
      query: (updatedRuleset) => ({
        url: `exploding-fee-schedules/${updatedRuleset.id}`,
        method: "PUT",
        body: updatedRuleset,
      }),
    }),
    deleteExplodingFeeSchedule: builder.mutation<any, string>({
      query: (id) => ({
        url: `exploding-fee-schedules/${id}`,
        method: "DELETE",
      }),
    }),
    uploadExplodingFeeScheduleCsv: builder.mutation<
      { data: { created: number; errors: string[] } },
      FormData
    >({
      query: (formData) => ({
        url: "exploding-fee-schedules/upload",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const {
  useGetAllExplodingFeeSchedulesQuery,
  useGetExplodingFeeScheduleByIdQuery,
  useCreateExplodingFeeScheduleMutation,
  useUpdateExplodingFeeScheduleMutation,
  useDeleteExplodingFeeScheduleMutation,
  useUploadExplodingFeeScheduleCsvMutation,
} = explodingFeeScheduleQueries;
